import { SVG, SVGProps } from './svg'

export function IconDrawingSettingAutosaveSaving(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M10 15a6 6 0 0 1 11.703-1.868A5.5 5.5 0 0 1 20.5 24h-10a4.5 4.5 0 0 1-.5-8.973V15zm-.954-.806a7.001 7.001 0 0 1 13.415-1.893A6.502 6.502 0 0 1 20.5 25h-10a5.5 5.5 0 0 1-1.454-10.806z"
      />
    </SVG>
  )
}
